import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallTitle from '../../../common-components/common-small-title';
import parser from 'html-react-parser';
interface PageProps {
    list: { title: string, description: string }[],
    listMedia: { title: string, subtitle: string, icon: string, link: string }[],
}
const Result: React.FC<PageProps> = ({ list, listMedia }) => {
    return (
        <div className="aimed-result">
            <FullWrapper>
                <div className="aimed-resultWrapper">
                    <div className="aimed-resultTitle">Результаты</div>
                    <div className="aimed-resultInner">
                        <div className="aimed-resultLeft">
                            <div className="aimed-resultParagrafList">
                                <div className="aimed-resultParagraf">
                                    С&nbsp;нуля разработали highload-платформу для выбора наилучшего
                                    решения на&nbsp;основе&nbsp;ИИ для определения симптомов
                                    по&nbsp;набору объективных данных и&nbsp;клинических
                                    исследований, а&nbsp;также определению заключительного
                                    клинического диагноза.
                                </div>
                                <div className="aimed-resultParagraf">
                                    Помогли сформировать уникальные датасеты, на&nbsp;которых уже
                                    обучаются отечественные ИИ-системы по&nbsp;первичной диагностике
                                    заболеваний и&nbsp;в&nbsp;дальнейшем станут основой системы
                                    поддержки принятия врачебных решений. В&nbsp;итоге это
                                    значительно улучшит качество медицинского обслуживания миллионов
                                    россиян, в&nbsp;том числе в&nbsp;отдаленных регионах.
                                </div>
                            </div>
                        </div>
                        <div className="aimed-resultRight">
                            На&nbsp;этом проекте помог опыт управления большой командой
                            и&nbsp;отлаженное взаимодействие с&nbsp;клиентом
                        </div>
                    </div>
                    <div className="aimed-resultList">
                        {list &&
                            list.map(item => (
                                <div className="aimed-resultItem" key={item.title}>
                                    <div
                                        className="aimed-resultText"
                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                    ></div>
                                    <div
                                        className="aimed-resultDescription"
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    ></div>
                                </div>
                            ))}
                    </div>
                    <div className="aimed-resultMedia">
                        <div className="aimed-resultMediaInner">
                            <CommonSmallTitle>СМИ о проекте:</CommonSmallTitle>
                            {listMedia.map(data => (
                                <a
                                    key={data.title}
                                    href={data.link}
                                    target="_blank"
                                    className="aimed-resultMediaWrapper"
                                    rel="noreferrer"
                                >
                                    <img
                                        className="aimed-resultMediaIcon"
                                        src={data.icon}
                                        alt="icon"
                                    />
                                    <div className="aimed-resultMediaInfo">
                                        <div className="aimed-resultMediaTitle">
                                            {parser(data.title)}
                                        </div>
                                        <div className="aimed-resultMediaSubtitle">
                                            {data.subtitle}
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Result;
